import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { fetchCaselet, getId, saveUnpublishedCaselet } from "../../../api";
import { useDispatch } from "react-redux";
import { SideBarIconProps } from "../../layout/Sidebar";
import { AppDispatch } from "../../../state/store";
import { initializeCaselet } from "../../caselet/caseletSlice";
import { LoadingScreen } from "./LoadingScreen";
import { Caselet, errorToast, get_user_data } from "../../../utils/common";
import {  ToastContainer } from "react-toastify";
import useRefreshToken from "../../../utils/useRefreshToken";
import { isTokenExpired } from "../../layout/Layout";
import { fetchCaselet, getId, saveUnpublishedCaselet } from "../../../api/axiosApi";

export const handleSaveCaseletClick = async (casletResponse: Caselet) => {

    try {
        const idResponse = await getId();
        // if (!idResponse.ok) {
        //     throw new Error(`Failed to fetch ID: ${idResponse.status}`);
        // }
        const id = await idResponse.data;
        console.log("Id: ", id);
        try {
            // const result = await saveCaselet(id.Id, casletResponse);
            const result = await saveUnpublishedCaselet(id.Id, casletResponse);
            const resultData = await result.data;
            return resultData.caselet_id;
        } catch (error) {
            console.error("Error saving caselet:", error);
        }
    } catch (error) {
        console.error("Failed to fetch ID and navigate", error);
    }
};

export const handleUpdateCaseletClick = async (caseletResponse: Caselet) => {
    // const refreshToken = useRefreshToken();
    // const navigate = useNavigate
    try {
        const access_token = localStorage.getItem("access_token");
        // const flag = await isTokenExpired(access_token);
        // console.log("flag: ", flag);
        // if (flag) {
        //     // await refreshToken();
        // }
        const result = await saveUnpublishedCaselet(Number.parseInt(caseletResponse.id), caseletResponse);
        const resultData = await result.data;
        return resultData;
    } catch (error) {
        console.error("Error saving caselet:", error);
    }
};

export const ChatCardButton: React.FC<SideBarIconProps> = ({ icon, text, to, response, conversation_id }: SideBarIconProps) => {
    const history = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const refreshToken = useRefreshToken();

    const handleFineTuneCaseletClick = useCallback(async () => {
        setLoading(true);
        // let userData: any = localStorage.getItem("user_data");
        // if (userData) {
        //     try {
        //         userData = JSON.parse(userData);
        //         // console.log("userData: ", userData);
        //     } catch (e) {
        //         console.error("Error parsing user_data from localStorage:", e);
        //         userData = null; // or set a default object if needed
        //     }
        // } else {
        //     userData = null;
        //     // or set a default object if needed
        // }

        let responseData = "";
        if (response) {
            responseData = response;
        }
       

        try {
            if (get_user_data() !== null && get_user_data() !== undefined) {
            //console.log("response data is", responseData);
            var getCaseletResponse = null;

            // const access_token = localStorage.getItem("access_token");
            // const flag = isTokenExpired(access_token);
            // // console.log("flag: ", flag)
            // if (flag) {
            //     await refreshToken();
            // }
            const userId =  get_user_data().email;
            getCaseletResponse = await fetchCaselet(userId, conversation_id);
            // if (getCaseletResponse.status === 401 || getCaseletResponse.status === 422) {
            //     document.cookie = `access_token_cookie=''; path=/; SameSite=None; Secure`;
            //     localStorage.removeItem("user_data");
            //     navigate("/user_login");
            // }
            // if (!getCaseletResponse.ok) {
            //     throw new Error(`Error! status: ${getCaseletResponse.status}`);
            // }

            const result = await getCaseletResponse.data;
            // console.log("result of fine tune ", result.caselet);
            let newCaselet: Caselet = result.caselet;
            for (let i = 0; i < newCaselet.challenges.length; i++) {
                newCaselet.challenges[i].title = "Decision Point " + (i + 1);
            }
            // adding new attributes in caselet like authorName and view
            newCaselet.authorName =  get_user_data().name;
            newCaselet.view = 0;
            newCaselet.published = false;
            // newCaselet.authorName = userData ? userData.name : "John Doe";
            const savedCaseletData = await handleSaveCaseletClick(newCaselet);

            //console.log("what is the value", savedCaseletData);
            newCaselet.id = savedCaseletData;
            console.log("newCaselet: ", newCaselet);
            dispatch(initializeCaselet(newCaselet));

            // history(to);
            history(`/unpublished-caselets/${savedCaseletData}`);
            
        }
        else{
            navigate("/user_login");
        }
        } catch (err) {
            errorToast("Error Occurred While Generating Caselet ");
        } finally {
            setLoading(false);
        }
    }, []);

    return (
        <div
            onClick={event => {
                if (to === "/unpublished-caselets/preview") {
                    handleFineTuneCaseletClick();
                } else if (to === "save as caselet") {
                    // handleSaveCaseletClick();
                }
            }}
            className={`sidebar-icon-2 group bg-grey-200`}
        >
            {loading ? (
                <LoadingScreen />
            ) : (
                <>
                    {icon}
                    <span className="sidebar-tooltip-2 group-hover:scale-100 mb-10">{text}</span>
                </>
            )}
        </div>
    );
};
